module.exports = __webpack_public_path__ + "img/Bodice-Back-Sleeve1-Kk-Lb.f3f9e03a.png";